<!-- 广告位 -->
<template>
  <div class="banner container flex-sb">
    
    <div v-for="(item,index) in bannerList" :key="index">
      <div class="banneritem">
      <a :href="item.link" target="_blank">
        <img  class="banneritem-img" :src="item.image" alt="" srcset="">
      </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getadvert } from '@/api/api';
// import exampleImage from '@/assets/images/components/R.gif';
export default {
  
  components: {},
  data() {
    return {
      bannerList: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    GETadvert(){
      getadvert().then(res => {
      
        this.bannerList = res;
        // console.log(this.bannerList,'11111111111111111111111111111111111');
      });
    }
  },
  created() {},
  mounted() {
this.GETadvert();
  }
};
</script>
<style lang='css' scoped >
@import "../style/banner.css";
</style>